module.exports = __webpack_public_path__ + "static/media/dm.b49b71b0.svg";